var map = {
	"./backgrounds/cellular-respiration.jpg": "7625",
	"./backgrounds/m1_t1.jpg": "872d",
	"./backgrounds/m1_t1_edge.jpg": "f9a4",
	"./backgrounds/m1_t2.jpg": "ed08",
	"./backgrounds/m1_t2_edge.jpg": "8e20",
	"./backgrounds/m2_t1.jpg": "0557",
	"./backgrounds/m2_t1_edge.jpg": "7d6a",
	"./backgrounds/m2_t2a.jpg": "983a",
	"./backgrounds/m2_t2a_edge.jpg": "b903",
	"./backgrounds/m2_t2b.jpg": "1c53",
	"./backgrounds/m2_t2b_edge.jpg": "9e55",
	"./backgrounds/m2_t2c.jpg": "6645",
	"./backgrounds/m2_t2c_edge.jpg": "6950",
	"./backgrounds/m2_t3.jpg": "ad07",
	"./backgrounds/m2_t3_edge.jpg": "7510",
	"./backgrounds/m2_t4.jpg": "f18c",
	"./backgrounds/m2_t4_edge.jpg": "988a",
	"./backgrounds/m2_t6.jpg": "db7f",
	"./backgrounds/m2_t6_edge.jpg": "cb6b",
	"./backgrounds/m3_t1.jpg": "2815",
	"./backgrounds/m3_t1_edge.jpg": "3aa0",
	"./backgrounds/m3_t2a_1.jpg": "7046",
	"./backgrounds/m3_t2a_1_edge.jpg": "f827",
	"./backgrounds/m3_t2a_2.jpg": "83b5",
	"./backgrounds/m3_t2a_2_edge.jpg": "4290",
	"./backgrounds/m3_t2a_3.jpg": "3bae",
	"./backgrounds/m3_t2a_3_edge.jpg": "845a",
	"./backgrounds/m3_t2b_1.jpg": "79a2",
	"./backgrounds/m3_t2b_1_edge.jpg": "d07e",
	"./backgrounds/m3_t2b_2.jpg": "1488",
	"./backgrounds/m3_t2b_2_edge.jpg": "d5d6",
	"./backgrounds/m3_t2b_3.jpg": "f768",
	"./backgrounds/m3_t2b_3_edge.jpg": "3e74",
	"./backgrounds/m3_t3.jpg": "c241",
	"./backgrounds/m3_t3_edge.jpg": "1ad1",
	"./backgrounds/m3_t4a.jpg": "454f",
	"./backgrounds/m3_t4a_edge.jpg": "3aa8",
	"./backgrounds/m3_t4a_text1.jpg": "f2da",
	"./backgrounds/m3_t4a_text2.jpg": "a785",
	"./backgrounds/m3_t4b.jpg": "ddbb",
	"./backgrounds/m3_t4b_edge.jpg": "37f5",
	"./backgrounds/m3_t4b_text1.jpg": "6277",
	"./backgrounds/m3_t4b_text2.jpg": "f0af",
	"./backgrounds/m3_t5.jpg": "5e09",
	"./backgrounds/m3_t5_edge.jpg": "5bee",
	"./backgrounds/photosynthesis.jpg": "ec4e",
	"./backgrounds/quiz.jpg": "5028",
	"./backgrounds/quiz_dark.jpg": "13a6",
	"./chemistry/12H2.png": "e0b8",
	"./chemistry/1N2.png": "7a05",
	"./chemistry/2NO3.png": "d485",
	"./chemistry/4NH3.png": "236a",
	"./chemistry/6CO2.png": "ed5c",
	"./chemistry/6H2O.png": "7bd0",
	"./chemistry/6O2.png": "e9b8",
	"./chemistry/CO2.png": "084f",
	"./chemistry/H2.png": "dbbf",
	"./chemistry/H2O.png": "18fb",
	"./chemistry/N2.png": "f859",
	"./chemistry/NH3.png": "52fd",
	"./chemistry/NO3.png": "da9d",
	"./chemistry/O2.png": "83df",
	"./chemistry/energy.png": "a678",
	"./chemistry/glucose.png": "5fed",
	"./chemistry/sun.png": "8c3a",
	"./components/algae.png": "4202",
	"./components/animals.png": "6774",
	"./components/carbon_dioxide.png": "ac07",
	"./components/carnivores.png": "4541",
	"./components/dead_land.png": "b873",
	"./components/dead_ocean.png": "0def",
	"./components/decomposers_land.png": "812e",
	"./components/decomposers_ocean.png": "d70d",
	"./components/factory.png": "956c",
	"./components/fish.png": "e731",
	"./components/fossil_fuel.png": "5260",
	"./components/herbivores.png": "7b80",
	"./components/plants.png": "4da9",
	"./components/tile_land.png": "bba3",
	"./components/tile_ocean.png": "96da",
	"./components/tile_selected.png": "f959",
	"./flag-en.png": "83a9",
	"./flag-en.svg": "46a9",
	"./flag-sv.png": "4503",
	"./flag-sv.svg": "f6f9",
	"./global.css": "150b",
	"./locales/en-US": "cff0",
	"./locales/en-US.json": "cff0",
	"./locales/sv-SE": "2d70",
	"./locales/sv-SE.json": "2d70",
	"./map/1961.jpg": "d64f",
	"./map/1962.jpg": "cb3a",
	"./map/1963.jpg": "3bce",
	"./map/1964.jpg": "a9db",
	"./map/1965.jpg": "f2c2",
	"./map/1966.jpg": "1c93",
	"./map/1967.jpg": "8a0f",
	"./map/1968.jpg": "4662",
	"./map/1969.jpg": "b946",
	"./map/1970.jpg": "96a7",
	"./map/1971.jpg": "0949",
	"./map/1972.jpg": "de82",
	"./map/1973.jpg": "6dfe",
	"./map/1974.jpg": "1109",
	"./map/1975.jpg": "8f8d",
	"./map/1976.jpg": "1833",
	"./map/1977.jpg": "4484",
	"./map/1978.jpg": "a0d1",
	"./map/1979.jpg": "f27c",
	"./map/1980.jpg": "7f4f",
	"./map/1981.jpg": "fdfb",
	"./map/1982.jpg": "5bab",
	"./map/1983.jpg": "9df6",
	"./map/1984.jpg": "b1a2",
	"./map/1985.jpg": "26e2",
	"./map/1986.jpg": "28cb",
	"./map/1987.jpg": "429b",
	"./map/1988.jpg": "de73",
	"./map/1989.jpg": "fb66",
	"./map/1990.jpg": "98f9",
	"./map/1991.jpg": "f1c4",
	"./map/1992.jpg": "617c",
	"./map/1993.jpg": "4dc5",
	"./map/1994.jpg": "a57b",
	"./map/1995.jpg": "d22c",
	"./map/1996.jpg": "d401",
	"./map/1997.jpg": "1f2b",
	"./map/1998.jpg": "d21b",
	"./map/1999.jpg": "b6b4",
	"./map/2000.jpg": "c682",
	"./map/2001.jpg": "0517",
	"./map/2002.jpg": "35b8",
	"./map/2003.jpg": "7ac9",
	"./map/2004.jpg": "7422",
	"./map/2005.jpg": "eda8",
	"./map/2006.jpg": "d8c9",
	"./map/2007.jpg": "0e82",
	"./map/2008.jpg": "5dda",
	"./map/2009.jpg": "6691",
	"./map/2010.jpg": "99dc",
	"./map/2011.jpg": "18ac",
	"./map/2012.jpg": "3b41",
	"./map/2013.jpg": "cdf1",
	"./map/2014.jpg": "01c5",
	"./map/2015.jpg": "86ca",
	"./map/2017.jpg": "f556",
	"./map/2018.jpg": "2b02",
	"./map/2019.jpg": "4043",
	"./map/2020.jpg": "87a0",
	"./map/2021.jpg": "745a",
	"./map/giss_navy_anomaly_celsius.jpg": "363d",
	"./map/giss_navy_anomaly_celsius.png": "095b",
	"./normals": "eec9",
	"./normals.json": "eec9",
	"./other/blue_arrow_legend.png": "61cb",
	"./other/orange_arrow_legend.png": "6953"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";